<template>
  <div class="voice-memo-modal" data-test-id="VoiceMemoComponent">
    <div>
      <div v-if="currentTime" data-test-id="VoiceMemoCounter" class="voice-memo-counter mb-3">
        <span>{{ minutes | formatTime }}:{{ seconds | formatTime }}</span>
      </div>
      <div v-if="!currentTime" data-test-id="VoiceMemoCounter" class="voice-memo-counter mb-3">
        <span>00:00</span>
      </div>
    </div>
    <div>
      <b-button
        v-if="isRecording"
        variant="danger"
        data-test-id="VoiceMemoStopButton"
        class="stop-button mr-2"
        @click="stopAndSend"
      >
        <i>Stop and Send</i>
      </b-button>
      <b-button variant="secondary" data-test-id="VoiceMemoCancelButton" class="cancel-button mr-2" @click="cancel">
        <i>Cancel</i>
      </b-button>
    </div>
  </div>
</template>

<script>
import { CaseEvent, CaseUpdateEventType } from "@/Case/CaseEvent";

export default {
  name: "VoiceMemo",
  filters: {
    formatTime(value) {
      if (value < 10) {
        return "0" + value;
      }
      return value;
    },
  },
  props: {
    eventType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      recorder: undefined,
      mediaStream: undefined,
      isRecording: false,
      startedTime: undefined,
      currentTime: undefined,
      audioChunks: [],
      audioBlob: undefined,
    };
  },
  computed: {
    seconds() {
      return Math.floor((this.currentTime / 1000) % 60);
    },
    minutes() {
      return Math.floor((this.currentTime / 1000 / 60) % 60);
    },
  },
  mounted() {
    this.record();
  },
  destroyed() {
    if (this.mediaStream) {
      this.mediaStream.getTracks().forEach((track) => {
        track.stop();
      });
    }
  },
  methods: {
    record() {
      if (navigator && navigator.mediaDevices) {
        if (!this.isRecording) {
          navigator.mediaDevices
            .getUserMedia({
              audio: true,
            })
            .then((stream) => {
              this.recorder = new MediaRecorder(stream, {
                mimeType: "audio/webm",
              });
              this.mediaStream = stream;
              let interval = undefined;

              this.recorder.ondataavailable = (e) => {
                this.audioChunks.push(e.data);
              };

              this.recorder.addEventListener("stop", () => {
                this.stopCounter(interval);

                this.audioBlob = new Blob(this.audioChunks, {
                  type: "audio/webm",
                });

                this.audioChunks = [];
                stream.getTracks().forEach((track) => {
                  if (track.readyState === "live") {
                    track.stop();
                  }
                });
                this.isRecording = false;

                this.$emit(CaseEvent.MODIFY, {
                  eventType: this.eventType,
                  id: `${this.eventType}.mp3`,
                  data: this.audioBlob,
                });

                this.$emit(CaseEvent.MODIFY, {
                  eventType: CaseUpdateEventType.chatMessage,
                  data: {
                    length: `${this.$options.filters.formatTime(this.minutes)}:${this.$options.filters.formatTime(
                      this.seconds,
                    )}`,
                    timestamp: Date.now(),
                    source: "web_ems",
                    type: "VOICE_MEMO",
                  },
                });
              });

              this.recorder.start();
              this.isRecording = true;
              interval = this.startCounter();
            });
        }
      }
    },
    stopAndSend() {
      this.recorder.stop();
    },
    cancel() {
      this.$emit("hide-modal");
    },
    startCounter() {
      this.startedTime = new Date();
      return setInterval(this.counter, 1000);
    },
    stopCounter(interval) {
      clearInterval(interval);
    },
    counter() {
      this.currentTime = Date.parse(new Date()) - Date.parse(this.startedTime);
    },
  },
};
</script>

<style scoped>
.voice-memo-modal {
  width: 100%;
  height: 100%;
  align-items: center;
  margin-bottom: 24px;
  z-index: 10;
}
.voice-memo-counter {
  font-size: 48px;
  font-weight: bold;
}
</style>
